import React, { useState, useEffect } from 'react';
import {
  TextInput,
  Field,
  FieldBody,
  FieldLabel,
  Button,
  Select,
  TextArea,
  Radio,
  Typeahead,
  TypeaheadItem,
  TypeaheadItemSuggestion,
  SearchIcon,
  Alert,
  Fieldset,
} from '@emorg-prd/react-standard';
import './index.css';
import RealEstateInterestType from '../../../../api/RealEstateInterestType';
import SourceSystem from '../../../../api/SourceSystem';
import SourceSystemIdType from '../../../../api/SourceSystemIdType';
import UnitOfMeasure from '../../../../api/UnitOfMeasure';
function RealEstateInterestItem(props) {
  const {
    index,
    realEstateInterest,
    handleREIToggle,
    removeREIField,
    handleInterestChange,
    realEstateInterestDropdown,
    handleRealEstateInterestSourceSystemChange,
    addRealEstateInterestSourceSystem,
    deleteRealEstateInterestSourceSystem,
    locationStateLocationId,
    handlePageError,
  } = props;
  const descMax = 250;
  const [interestTypeLevel1Parents, setInterestTypeLevel1Parents] = useState([]);
  const [interestTypeLevel2Parents, setInterestTypeLevel2Parents] = useState([]);
  const [interestTypeOptions, setInterestTypeOptions] = useState([]);
  const [unitOfMeasureDropdown, setUnitOfMeasureDropdown] = useState([]);
  const [isAdvancedOptionsVisible, setIsAdvancedOptionsVisible] = useState(false);
  const [
    realEstateInterestSourceSystemDropdown,
    setRealEstateInterestSourceSystemDropdown,
  ] = useState([]);
  const [
    realEstateInterestSourceSystemTypeDropdown,
    setRealEstateInterestSourceSystemTypeDropdown,
  ] = useState([]);

  useEffect(() => {
    RealEstateInterestType.getAll().then((res) => {
      sortInterestTypeData(res);
    }).catch((error) => {
      handlePageError(error.message);
    });
    UnitOfMeasure.getAll().then((res) => {
      setUnitOfMeasureDropdown(res);
    }).catch((error) => {
      handlePageError(error.message);
    });
    SourceSystem.getRealEstateSourceSystems().then((res) => {
      setRealEstateInterestSourceSystemDropdown(res);
    }).catch((error) => {
      handlePageError(error.message);
    });
    SourceSystemIdType.getAll().then((res) => {
      setRealEstateInterestSourceSystemTypeDropdown(res);
    }).catch((error) => {
      handlePageError(error.message);
    });
    if (realEstateInterest.realEstateInterestSizeUOM ||
      realEstateInterest.realEstateInterestArea) {
        expandAdvancedOptions();
      }
  }, []);

  const sortInterestTypeData = (interestTypes) => {
    let level1Parents = interestTypes.filter((type) => {
      if (type.parentRealEstateInterestType === 0) {
        return type;
      }
      return null;
    });
    let level2Parents = interestTypes.filter((type) => {
      var parent = level1Parents.find((parent) =>
        parent.realEstateInterestTypeId === type.parentRealEstateInterestType
      );
      if (parent) {
        return type;
      }
      return null;
    });
    let typeOptions = interestTypes.filter((type) => {
      var parent = level2Parents.find((parent) =>
        parent.realEstateInterestTypeId === type.parentRealEstateInterestType
      );
      if (parent) {
        return type;
      }
      return null;
    });
    setInterestTypeLevel1Parents(level1Parents);
    setInterestTypeLevel2Parents(level2Parents);
    setInterestTypeOptions(typeOptions);
  };

  const renderInterestTypeDropdown = (interestTypeLevel1) => {
    return (
      <>
        <option
          key={interestTypeLevel1.realEstateInterestTypeId}
          label={interestTypeLevel1.realEstateInterestTypeName}
          style={{ fontFamily: 'EMprintSemibold' }}
        ></option>
        {interestTypeLevel2Parents.map((interestTypeLevel2) => {
          if (
            interestTypeLevel2.parentRealEstateInterestType ===
            interestTypeLevel1.realEstateInterestTypeId
          ) {
            return (
              <optgroup
                key={interestTypeLevel2.realEstateInterestTypeId}
                label={'\u00A0\u00A0' + interestTypeLevel2.realEstateInterestTypeName}
              >
                {interestTypeOptions.map((interestType) => {
                  if (
                    interestType.parentRealEstateInterestType ===
                    interestTypeLevel2.realEstateInterestTypeId
                  ) {
                    return (
                      <option
                        key={interestType.realEstateInterestTypeId}
                        id={interestType.realEstateInterestTypeId}
                        value={interestType.realEstateInterestTypeName}
                        className='rei-type'
                      >
                        {'\u00A0' + interestType.realEstateInterestTypeName}
                      </option>
                    )
                  }
                  return null;
                })}
              </optgroup>
            )
          }
          return null;
        })}
      </>
    )
  }

  const renderUnitOfMeasureDropdown = (unitOfMeasure) => (
    <option
      key={unitOfMeasure.UomCode}
      id={unitOfMeasure.UomCode}
      value={unitOfMeasure.UomCode}
    >
      {unitOfMeasure.UomName}
    </option>
  );

  const renderRealEstateInterestSourceSystemSelect = (realEstateInterestSourceSystem) => (
    <option
      id={realEstateInterestSourceSystem.sourceSystemId}
      key={realEstateInterestSourceSystem.sourceSystemId}
      value={realEstateInterestSourceSystem.sourceSystemName}
    >
      {realEstateInterestSourceSystem.sourceSystemName}
    </option>
  );

  const renderRealEstateInterestSourceSystemTypeSelect = (
    realEstateInterestSourceSystemType
  ) => (
    <option
      id={realEstateInterestSourceSystemType.sourceSystemIdTypeId}
      key={realEstateInterestSourceSystemType.sourceSystemIdTypeId}
      value={realEstateInterestSourceSystemType.sourceSystemIdTypeName}
    >
      {realEstateInterestSourceSystemType.sourceSystemIdTypeName}
    </option>
  );

  const expandAdvancedOptions = () => {
    setIsAdvancedOptionsVisible(!isAdvancedOptionsVisible);
  };
const getAvailableREISourceSystemTypes = (
  sourceSystemIndex,
  sourceSystemName
) => {
  const selectedTypeIds =
    realEstateInterest.realEstateInterestSourceSystemRelate
      .filter(
        (item, index) =>
          index !== sourceSystemIndex
      )
      .map(item =>
        String(item.realEstateInterestSourceSystemTypeId)
      )
      .filter(Boolean);

  return realEstateInterestSourceSystemTypeDropdown.filter(
    type =>
      type.sourceSystemIdTypeDesc.includes(sourceSystemName) &&
      (
        !selectedTypeIds.includes(
          String(type.sourceSystemIdTypeId)
        ) ||
        String(type.sourceSystemIdTypeId) ===
        String(
          realEstateInterest
            .realEstateInterestSourceSystemRelate[
              sourceSystemIndex
            ]?.realEstateInterestSourceSystemTypeId
        )
      )
  );
};
  return (
    <Fieldset key={`${index}`} className='rei-fieldset'>
      <div className='radio-row'>
        <Radio
          style={{
            paddingLeft: '5px',
            border: 0,
            background: 'transparent',
          }}
          id='rbNewREI'
          value={'new'}
          label='Create New REI'
          onClick={(e) => handleREIToggle(e, true, index)}
          checked={realEstateInterest.isNew === true}
        />
        <Radio
          style={{
            paddingLeft: '5px',
            border: 0,
            background: 'transparent',
          }}
          id='rbSelectREI'
          value={'existing'}
          label='Select Existing REI'
          onClick={(e) => handleREIToggle(e, false, index)}
          checked={realEstateInterest.isNew === false}
        />
      </div>

      {!realEstateInterest.isNew &&
      realEstateInterest.isREILocked &&
      realEstateInterest.locationId !== locationStateLocationId ? (
        <Alert variant='error' onClose={() => {}}>
          This Real Estate Interest is currently linked as primary to a location and
          cannot be reassigned
        </Alert>
      ) : realEstateInterest.locationId !== locationStateLocationId &&
          realEstateInterest.isNew !== true  ? (
        <Alert>This will reassign the selected REI from it's existing location</Alert>
      ) : (
        <div />
      )}

      <div className='input-row-with-note'>
        {!realEstateInterest.isNew ? (
          <Field>
            <FieldLabel>Real Estate Interest Name *</FieldLabel>
            <FieldBody>
              <form className='em-c-search-form'>
                <div className='em-c-search__body'>
                  <Typeahead
                    className='interest'
                    // Error when REI not selected
                    error={
                      !realEstateInterest.realEstateInterestId ||
                      realEstateInterest.isREILocked
                    }
                    onChange={(e, value) => {
                      handleInterestChange('name', index, e, value.realEstateInterestName, value);
                    }}
                    inputProps={{
                      className: 'search-bar',
                      onChange: (e) => {
                        handleInterestChange('name', index, e, e.target.value, null);
                      },
                      onKeyPress: (e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                        }
                      },
                      value: realEstateInterest.realEstateInterestName,
                      placeholder: 'Search',
                    }}
                  >
                    {realEstateInterestDropdown[parseInt(index)]
                      .filter((interest) =>
                        interest.realEstateInterestName.toLowerCase().trim()
                          .includes(realEstateInterest.realEstateInterestName.trim().toLowerCase())
                      )
                      .map((interest) => (
                        <TypeaheadItem
                          key={interest.realEstateInterestId}
                          value={interest}
                        >
                          <TypeaheadItemSuggestion>
                            <span>{`${interest.realEstateInterestName} `}</span>
                          </TypeaheadItemSuggestion>
                        </TypeaheadItem>
                      ))}
                  </Typeahead>
                  <Button className='create-location-secondary'>
                    <SearchIcon size='small' />
                  </Button>
                </div>
              </form>
            </FieldBody>
          </Field>
        ) : (
          <TextInput
            className='rei-name-input'
            label='Real Estate Interest Name *'
            value={realEstateInterest.realEstateInterestName}
            note={
              realEstateInterest.realEstateInterestName.length < 5
                ? 'Minimum length of 5 characters'
                : realEstateInterest.realEstateInterestName.length > 100
                  ? 'Maximum length of 100 characters'
                  : 'This will create a new REI called ' +
                    realEstateInterest.realEstateInterestName
            }
            onChange={(e, value) => {
              handleInterestChange('name', index, e, e.target.value, value);
            }}
            error={
              realEstateInterest.realEstateInterestName.length < 5 ||
              realEstateInterest.realEstateInterestName.length > 50
            }
          />
        )}
        <Select
          label='Interest Type *'
          value={realEstateInterest.realEstateInterestTypeName}
          onChange={(e) => handleInterestChange('type', index, e, null)}
          error={!realEstateInterest.realEstateInterestTypeId}
          style={{ paddingLeft: '15px' }}
          disabled={realEstateInterest.isREILocked}
        >
          <option value=''>{'\u00A0'}Select</option>
          {interestTypeLevel1Parents.map(renderInterestTypeDropdown)}
        </Select>

        <Radio
          style={{
            paddingTop: '30px',
            paddingLeft: '5px',
            border: 0,
            background: 'transparent',
          }}
          id='primary-interest'
          value={index}
          name='example radio'
          label='Primary'
          onClick={(e) => handleInterestChange('primary', index, e, null)}
          checked={realEstateInterest.primary}
        />

        <Button
          style={{ paddingTop: '42px', paddingLeft: '20px' }}
          className='small-margin'
          variant='tertiary'
          size='small'
          onClick={() => removeREIField(index)}
        >
          × Remove Real Estate Interest
        </Button>
      </div>

      <Field>
        <FieldLabel></FieldLabel>
        <div>
          <TextArea
            className='description'
            label='Real Estate Interest Description'
            placeholder=''
            rows='3'
            error={(realEstateInterest.realEstateInterestDesc || '').length > descMax}
            value={realEstateInterest.realEstateInterestDesc}
            onChange={(e) =>
              handleInterestChange('realEstateInterestDesc', index, e, null)
            }
            disabled={realEstateInterest.isREILocked}
          />
        </div>

        <p style={{ fontSize: 'small' }}>
          Characters Remaining:{' '}
          {descMax - (realEstateInterest.realEstateInterestDesc || '').length}
        </p>
        <Button
          className='small-margin'
          variant='tertiary'
          size='small'
          style={{ paddingTop: '20px', paddingLeft: '15px' }}
          onClick={() => expandAdvancedOptions()}
        >
          + Advanced Options
        </Button>
      </Field>
      {isAdvancedOptionsVisible && (
        <div style={{ paddingLeft: '30px' }}>
          <div className='input-row'>
            <Select
              label='UOM'
              value={realEstateInterest.realEstateInterestSizeUOM}
              selectProps={{ className: 'reiAdvancedOptions' }}
              onChange={(e) =>
                handleInterestChange('realEstateInterestSizeUOM', index, e, null)
              }
            >
              <option value=''>Select</option>
              {unitOfMeasureDropdown.map(renderUnitOfMeasureDropdown)}
            </Select>

            <TextInput
              className='reiAdvancedOptions'
              label='Area'
              placeholder=''
              value={realEstateInterest.realEstateInterestArea}
              onChange={(e) =>
                handleInterestChange('realEstateInterestArea', index, e, null)
              }
            />
          </div>
        </div>
      )}

      {realEstateInterest.realEstateInterestSourceSystemRelate.map(
        (sourceSystem, sourceSystemIndex) => (
          <div className='input-row' key={`${sourceSystemIndex}`}>
            <Select
              style={{ paddingRight: '15px' }}
              selectProps={{
                className: 'rei-source-system-field',
              }}
              label='Source System'
              value={sourceSystem.realEstateInterestSourceSystemName}
              error={!sourceSystem.realEstateInterestSourceSystemId}
              onChange={(e) =>
                handleRealEstateInterestSourceSystemChange('sourceSystemName',
                  sourceSystemIndex, index, e)
              }
            >
              <option value=''>Select</option>
              {realEstateInterestSourceSystemDropdown.map(
                renderRealEstateInterestSourceSystemSelect
              )}
            </Select>
            <Select
              style={{ paddingRight: '15px' }}
              selectProps={{
                className: 'rei-source-system-field',
              }}
              label='Source System Type'
              value={sourceSystem.realEstateInterestSourceSystemIdTypeName}
              error={!sourceSystem.realEstateInterestSourceSystemTypeId}
              onChange={(e) =>
                handleRealEstateInterestSourceSystemChange('sourceSystemIdTypeName',
                  sourceSystemIndex, index, e)
              }
            >
              <option value=''>Select</option>
              {/* {realEstateInterestSourceSystemTypeDropdown
                .filter((type) =>
                  type.sourceSystemIdTypeDesc.includes(
                    sourceSystem.realEstateInterestSourceSystemName
                  )
                )
                .map(renderRealEstateInterestSourceSystemTypeSelect)} */}
                {getAvailableREISourceSystemTypes(
                 sourceSystemIndex,
                 sourceSystem.realEstateInterestSourceSystemName
                   )
                .map(renderRealEstateInterestSourceSystemTypeSelect)}
            </Select>
            <TextInput
              className='rei-source-system-field'
              label='Source System Reference ID'
              value={sourceSystem.realEstateInterestSourceSystemReferenceID}
              error={!sourceSystem.realEstateInterestSourceSystemReferenceID}
              onChange={(e) =>
                handleRealEstateInterestSourceSystemChange('sourceSystemID',
                  sourceSystemIndex, index, e)
              }
            />
            <Button
              style={{ paddingTop: '42px', paddingLeft: '25px' }}
              className='small-margin'
              variant='tertiary'
              size='small'
              onClick={() =>
                deleteRealEstateInterestSourceSystem(sourceSystemIndex, index)
              }
            >
              × Remove REI Source System
            </Button>
          </div>
        )
      )}

      <div>
        <Button
          className='small-margin'
          variant='tertiary'
          size='small'
          style={{ paddingTop: '0px', marginTop: '0px' }}
          onClick={() => addRealEstateInterestSourceSystem(index)}
        >
          + Add REI Source System
        </Button>
      </div>
    </Fieldset>
  );
}
export default RealEstateInterestItem;
